const keyReducer = (state, action) => {
  let parentPlaceholder = null
  if (action.key && !action.key.includes("extra")) {
    parentPlaceholder = action.key + "-extra"
  }
  switch (action.type) {
    case "update":
      if (action.key) {
        return {
          ...state,
          [action.key]: action.value,
          [parentPlaceholder]: action.key,
        }
      }
      return state
    case "remove":
      delete state[action.key]
      const extra = Object.values(state).find(x => x === action.key)
      if (extra) {
        delete state[`${extra}-extra`]
      }
      return state
    case "extraKeys":
      return {
        ...state,
        extraKey: action.extraKeys[0],
      }
    case "resurrect":
      return action.keys
    case "reset":
      return []
    default:
      break
  }
}

export default keyReducer
